// @flow
import * as React from 'react'

import { Global } from './Global'
import { Hire } from './Hire'
import { Plan } from './Plan'
import { Track } from './Track'
import type { Props } from './types'

export const Logo = ({
  dark,
  kind,
}: {
  ...Props,
  kind: 'global' | 'hire' | 'plan' | 'track',
}) => {
  switch (kind) {
    case 'global':
      return <Global dark={dark} />
    case 'hire':
      return <Hire dark={dark} />
    case 'plan':
      return <Plan dark={dark} />
    case 'track':
      return <Track dark={dark} />
    default:
      ;(kind: empty)
      throw new Error()
  }
}
